import { Link } from 'gatsby';
import Layout from "../../../../src/components/layout";
import SEO from "../../../../src/components/seo";
import Title from "../../../../src/components/title";
import Illustration from "../../../../src/components/illustration";
import { Images as images, Icons as icons } from "../../../../src/data/assets";
import * as React from 'react';
export default {
  Link,
  Layout,
  SEO,
  Title,
  Illustration,
  images,
  icons,
  React
};